import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBar,
    MatSnackBarAction,
    MatSnackBarActions,
    MatSnackBarLabel,
    MatSnackBarRef,
} from '@angular/material/snack-bar';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { GraphQLFormattedError } from 'graphql';

@Component({
    selector: 'app-error-snackbar',
    imports: [
        MatButtonModule,
        MatSnackBarLabel,
        MatSnackBarActions,
        MatSnackBarAction,
        MatDivider,
    ],
    templateUrl: './error-snackbar.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './error-snackbar.css',
})
export class ErrorSnackbarComponent {
    public data: any = inject(MAT_SNACK_BAR_DATA);
    errors: GraphQLFormattedError[] = this.data.errors;
    snackBarRef = inject(MatSnackBarRef);
}

export function openErrorSnackbarOnError(snackbar: MatSnackBar) {
    return (result: { error?: unknown }) => {
        if (!result.error) return;
        const errors = CombinedGraphQLErrors.is(result.error)
            ? [...result.error.errors]
            : [{ message: (result.error as Error).message }];
        snackbar.openFromComponent(ErrorSnackbarComponent, {
            data: { errors },
        });
    };
}
